import { useTranslation } from 'react-i18next'
import type { StepProgressStatus } from '../../StepProgress'
import * as $ from './StepProgressItem.styled'

interface StepProgressItemProps {
  number: number
  label: string
  status: StepProgressStatus
  isFirst: boolean
  isLast: boolean
  onClick?: () => void
}

export const StepProgressItem: React.FC<StepProgressItemProps> = ({
  number,
  label,
  status,
  isFirst,
  isLast,
  onClick,
}) => {
  const { t } = useTranslation()
  const isComplete = status === 'complete'
  const isHighlighted = status === 'current' || isComplete

  const content = (
    <>
      <$.Indicator isHighlighted={isHighlighted} aria-hidden={true}>
        <$.StepNumber isVisible={!isComplete}>{number}</$.StepNumber>
        <$.CheckIcon isVisible={isComplete} />
      </$.Indicator>
      <$.Label isHighlighted={isHighlighted}>
        {label}
        {isComplete && <$.VisuallyHidden> {t('stepProgress::completed')}</$.VisuallyHidden>}
        {status === 'skipped' && <$.VisuallyHidden> {t('stepProgress::skipped')}</$.VisuallyHidden>}
      </$.Label>
    </>
  )

  return (
    <$.Item aria-current={status === 'current' ? 'step' : undefined}>
      {!isFirst && (
        <$.Connector side="start" aria-hidden={true}>
          <$.ConnectorFill side="start" isFilled={status !== 'incomplete'} />
        </$.Connector>
      )}
      {!isLast && (
        <$.Connector side="end" aria-hidden={true}>
          <$.ConnectorFill side="end" isFilled={isComplete || status === 'skipped'} />
        </$.Connector>
      )}
      {onClick ? (
        <$.Button type="button" onClick={onClick}>
          {content}
        </$.Button>
      ) : (
        <$.Content>{content}</$.Content>
      )}
    </$.Item>
  )
}
